export default class TimeSelector {
    constructor(root) {
        this.input = root.input;
        this.main = root.main;
        this.config = root.config;
        this.helper = root.helper;

        this.showed = false;
        this.builded = false;
    }

    build() {
        if (this.builded) {
            return;
        }

        const config = this.config.get();
        const { workTime, dateFormat, locale } = config;

        const itemsInRow = 4;
        const timeStartHour = workTime.start.hour;
        const timeStartMinute = workTime.start.minute;
        const timeFinishHour  = (workTime.finish.hour === 0) ? 24 : workTime.finish.hour;
        const timeFinishMinute = workTime.finish.minute;
        const interval = workTime.interval;
        let count = 0;

        const createNodes = () => {
            this.$time_selector = $('<div class="f-calendar__time-selector"></div>');
            this.$time_selector_close_btn = $(`
                <div class="f-calendar__time-selector--close-btn">
                    <svg class="back-icon" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.00018 5.00005L8.00018 9.00005L7.00018 10.0001L2.00018 5.00005L7.00018 5.34058e-05L8.00018 1.00005L4.00018 5.00005Z" fill="#222D39"/>
                    </svg>
                </div>
            `);

            this.$header = $('<div class="f-calendar__time-selector--header"></div>');
            this.$body = $('<div class="f-calendar__time-selector--body"></div>');
            this.$title = $(`<div class="f-calendar__time-selector--title">${ locale.choose_time_desc }</div>`);
            this.$list = $('<div class="f-calendar__time-selector--list f-calendar_scrollable"></div>');
        };

        const buildList = () => {
            this.$list.append(this.$title);

            let iHour = timeStartHour;
            let iMinute = timeStartMinute;

            /* eslint no-loops/no-loops: 0 */
            while (iHour <= timeFinishHour) {
                if (iMinute === 60) {
                    iHour += 1;
                    iMinute = 0;

                    continue;
                }

                const endCycle = (iHour === 24) || (iHour === timeFinishHour && iMinute === timeFinishMinute);

                if (endCycle) {
                    break;
                }

                const time = this.helper.getTimeStr({
                    hour: iHour,
                    minute: iMinute
                });

                const $item = $(`<div class="f-calendar__time-selector--item" hour="${ iHour }" minute="${ iMinute }"">${ time }</div>`);

                this.$list.append($item);

                count += 1;

                iMinute += interval;
            }

            // Добавляем пустые итемы
            let needAddStubs = (count % itemsInRow) > 0 ? itemsInRow - (count % itemsInRow) : 0;

            if (needAddStubs) {
                while (needAddStubs > 0) {
                    this.$list.append($('<div class="f-calendar__time-selector--item f-calendar__time-selector--item_stub"> </div>'));

                    needAddStubs -= 1;
                }
            }
        };

        const buildBody = () => {
            this.$list.prepend(this.$title);
            this.$body.append(this.$list);

            this.$time_selector.append(this.$time_selector_close_btn);
            this.$time_selector.append(this.$header);
            this.$time_selector.append(this.$body);

            this.main.$container.append(this.$time_selector);

            if (dateFormat.hour12) {
                this.$time_selector.addClass('f-calendar__time-selector_ampm');
            }
        };

        createNodes();
        buildList();
        buildBody();

        this.builded = true;
    }

    show(inputValue) {
        if (!this.builded) {
            return false;
        }

        this.showed = true;

        const { locale } = this.config.get();

        const {
            date,
            month,
            year
        } = inputValue.parsed;

        this.selectTime(inputValue.parsed);
        this._checkLimits();

        this.$header.html(`${ date } ${ locale.month_d[month] }, ${ year }`);
        this.$time_selector.addClass('f-calendar__time-selector_opened');

        let $time = this.$list.find('.f-calendar__time-selector--item_active');

        if (!$time.length) {
            $time = this.$list.find('.f-calendar__time-selector--item').not('.f-calendar__time-selector--item_disabled').first();
        }

        // Скролим к выбранному или ближайшему числу
        this.scroll($time);
    }

    hide() {
        if (!this.builded) {
            return false;
        }

        this.showed = false;

        this.$time_selector.removeClass('f-calendar__time-selector_opened');
    }

    selectTime({ hour, minute }) {
        this.clearSelectedTime();

        this.$time_selector.find(`[hour=${ hour }][minute=${ minute }]`)
            .addClass('f-calendar__time-selector--item_active');
    }

    clearSelectedTime() {
        this.$time_selector.find('.f-calendar__time-selector--item_active')
            .removeClass('f-calendar__time-selector--item_active');
    }

    scroll($time) {
        if (!$time.length) {
            console.warn('TimeSelector.scroll() - Time not found');
            return;
        }

        // Обнуляем скролл
        this.$list.scrollTop(0);

        const listRect = this.$list[0].getBoundingClientRect();
        const itemRect = $time[0].getBoundingClientRect();

        const needScroll = (listRect.bottom - 20) < itemRect.bottom;

        if (needScroll) {
            // Измеряем куда будем скроллить
            const scrollTo = $time[0].offsetTop - 100;

            // Скроллим
            this.$list.scrollTop(scrollTo);
        }
    }

    _checkLimits() {
        const {
            dateRange,
            upperLimit,
            lowerLimit
        } = this.config.get();

        const selectedDate = this.input.state.parsed;
        const $items = this.$list.find('.f-calendar__time-selector--item').not('.f-calendar__time-selector--item_stub');
        $items.removeClass('f-calendar__time-selector--item_disabled');

        if (dateRange === 'future') {
            const needCheck = (
                (selectedDate.date === lowerLimit.date) &&
                (selectedDate.month === lowerLimit.month) &&
                (selectedDate.year === lowerLimit.year)
            );

            if (needCheck) {
                $items.each((index, item) => {
                    const $item = $(item);

                    const hour = Number($item.attr('hour'));
                    const minute = Number($item.attr('minute'));

                    const needDisabled = (
                        (hour < lowerLimit.hour) ||
                        ((hour === lowerLimit.hour) && (minute <= lowerLimit.minute))
                    );

                    if (needDisabled) {
                        $item.addClass('f-calendar__time-selector--item_disabled');
                    }
                });
            }
        }
        else if (dateRange === 'past') {
            const needCheck = (
                (selectedDate.date === upperLimit.date) &&
                (selectedDate.month === upperLimit.month) &&
                (selectedDate.year === upperLimit.year)
            );

            if (needCheck) {
                $items.each((index, item) => {
                    const $item = $(item);

                    const hour = Number($item.attr('hour'));
                    const minute = Number($item.attr('minute'));

                    const needDisabled = (
                        (hour > upperLimit.hour) ||
                        ((hour === upperLimit.hour) && (minute >= upperLimit.minute))
                    );

                    if (needDisabled) {
                        $item.addClass('f-calendar__time-selector--item_disabled');
                    }
                });
            }
        }
    }
}
